<template>
	<div class="row d-flex justify-content-center align-items-center text-left mb-3">
		<div class="col-12">
			{{item.nev}}
		</div>
		<div class="col-6">
			<div class="mui-textfield mui-textfield">
		    	<textarea v-model="item.rendmegj" rows="1">
		    	</textarea>
		    	<label>Rendelési megj.</label>
		  	</div>
			<!--<label>Rendelési megj.</label>
			<input type="text" class="form-control" v-model="item.rendmegj">-->
		</div>
		<div class="col-6">
			<div class="input-group">
			  	<input type="number" class="form-control" v-model="item.ar">
			  	<div class="input-group-append">
			    	<span class="input-group-text">Ft / db</span>
			  	</div>
			</div>
		</div>
		<div class="col-6">
			<div class="row d-flex justify-content-center">
				<div class="input-group col-10">
					<div class="input-group-prepend">
						<button
							class="btn btn-outline-primary"
							@click.prevent="rFromCart(index)"
						>
							<i class="fa fa-minus"></i>
						</button>
					</div>
						<input type="number" class="form-control text-center" v-model="item.db">
					<div class="input-group-append">
						<button
							class="btn btn-outline-primary"
							@click.prevent="pToCart(index)"
						>
							<i class="fa fa-plus"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
		
		<div class="col-6">
			{{ ar }} Ft
			<button class="btn btn-outline-danger m-1" @click.prevent="removeFromCart(index)">
				<i class="fa fa-trash"></i>
			</button>
		</div>
		<div class="col-12">
			<hr>
		</div>
	</div>
</template>
<script>
import {mapGetters,mapActions} from 'vuex'
export default {
	name: 'cart_item',
	props: ['item','index'],
	methods: {
		...mapActions(['removeFromCart','addToCart','rFromCart','pToCart','updateCartItem'])
	},
	computed: {
		ar(){
			return this.item.ar * this.item.db
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/cart/cartItem_v2.vue